import React from "react";
import { Segment, Placeholder } from "semantic-ui-react";

function MiniPlaceholder() {
  return (
    <Segment size="mini" raised>
      <Placeholder>
        <Placeholder.Header image>
          <Placeholder.Line />
        </Placeholder.Header>
        <Placeholder.Paragraph>
          <Placeholder.Line length="medium" />
          <Placeholder.Line length="full" />
        </Placeholder.Paragraph>
      </Placeholder>
    </Segment>
  );
}

export default MiniPlaceholder;
